import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';

const FAQS = [
  {
    q: '什么是漫画岛？',
    a: '漫画岛是一个专注"发现好漫"的中文漫画推荐平台。编辑团队每日精选热门新作与潜力佳作，通过编辑精选、每日推荐、新作尝鲜等频道，帮助你高效找到值得入坑的漫画作品，避免踩雷。',
  },
  {
    q: '漫画岛上的作品需要付费吗？',
    a: '漫画岛的推荐与浏览功能完全免费。我们为你整理分类、榜单与编辑推荐，帮助你发现好作品；具体作品的阅读方式以各作品官方平台为准。',
  },
  {
    q: '如何快速找到适合我的漫画？',
    a: '你可以通过首页的编辑精选、每日推荐、新作尝鲜与热门榜单发现作品，也可以进入分类页，按热血、恋爱、奇幻、科幻、悬疑、日常等口味进行挑选。',
  },
  {
    q: '可以收藏或给漫画评分吗？',
    a: '目前你可以浏览、收藏推荐并阅读作品详情。评分与收藏体系正在建设中，后续会陆续上线，敬请期待。',
  },
  {
    q: '如何联系漫画岛团队？',
    a: '你可以前往"关于我们"页面查看团队介绍与联系方式，也可以通过邮箱 contact@manhuadao.cn 与我们取得联系。',
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading eyebrow="常见问题" title="你可能想知道的" desc="关于漫画岛的常见问题，答案都在这里。" />
        <div className="mt-8 flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-base font-bold text-foreground-950 md:text-lg">{f.q}</h3>
                  <i className={`ri-add-line text-xl text-foreground-500 transition-transform ${isOpen ? 'rotate-45' : ''}`}></i>
                </button>
                {isOpen && <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}